"use strict";

import { useSupplierPortalAsideItems } from '@autoguru/aside-items';
import { ExpandSideNav } from '@autoguru/expand-side-nav';
import { MFE_BASE_PATH, RETAIL_LOGOUT_URL, RETAIL_URL } from '@autoguru/global-configs';
import { useSelectedGlobalSupplier } from '@autoguru/supplier-provider';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppAside = () => {
  const {
    slug
  } = useSelectedGlobalSupplier();
  const asideItems = useSupplierPortalAsideItems({
    baseUrl: MFE_BASE_PATH,
    supplierSlug: slug
  });
  return /*#__PURE__*/_jsx(ExpandSideNav, {
    includeAuth: true,
    logoutRedirect: RETAIL_URL,
    logoutUrl: `${RETAIL_LOGOUT_URL}`,
    asideItems: asideItems
  });
};